"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styled = require("./styled");
var _Loader = _interopRequireDefault(require("../Loader"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactDropzone = require("react-dropzone");
var _reactI18next = require("react-i18next");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DragAndDrop = _ref => {
  let {
    clearFileAfterChange,
    error,
    height = '40px',
    margin = '0px',
    loading,
    onFileChange = () => {},
    width = '100%'
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [currentFile, setCurrentFile] = (0, _react.useState)(null);
  const onDrop = (0, _react.useCallback)(acceptedFiles => {
    if (!(0, _isEmpty.default)(acceptedFiles)) {
      const newFile = acceptedFiles[0];
      setCurrentFile(!clearFileAfterChange ? newFile : null);
      onFileChange(newFile);
    }
  }, [clearFileAfterChange, onFileChange, setCurrentFile]);
  const {
    getRootProps,
    getInputProps
  } = (0, _reactDropzone.useDropzone)({
    onDrop
  });
  const containerProps = {
    error,
    height,
    margin,
    width
  };
  const {
    name
  } = currentFile !== null && currentFile !== void 0 ? currentFile : {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread(_objectSpread({}, getRootProps()), containerProps), {}, {
    children: [loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
      active: true
    }), !loading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({}, getInputProps())), !currentFile && !name ? t('Arrastra el archivo o haz click aquí') : name]
    })]
  }));
};
DragAndDrop.propTypes = {
  clearFileAfterChange: _propTypes.default.bool,
  error: _propTypes.default.bool,
  height: _propTypes.default.string,
  loading: _propTypes.default.bool,
  margin: _propTypes.default.string,
  onFileChange: _propTypes.default.func,
  width: _propTypes.default.string
};
var _default = exports.default = DragAndDrop;